<div mat-dialog-title class="dialog-title">
  <span>{{ orderData?.code }} v{{ orderData?.version }}</span>
</div>

<div mat-dialog-content class="dialog-content">

  <ng-container *ngIf="orderRows.length > 0; else noData">

    <!-- Accordion livello 1: righe d'ordine (OrdersOrderRowsRel) -->
    <mat-accordion [multi]="true" class="rows-accordion">

      <mat-expansion-panel *ngFor="let rowModel of orderRows" class="row-panel">

        <mat-expansion-panel-header>
          <mat-panel-title class="row-panel-title">
            {{ rowModel.row.descCategory }} – {{ rowModel.row.descMacroPhase }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Accordion livello 2: lavorazioni (OrderRowsOrderPhasesRel) -->
        <mat-accordion [multi]="true" class="phases-accordion">

          <mat-expansion-panel
            *ngFor="let phaseModel of rowModel.phases"
            class="phase-panel">

            <mat-expansion-panel-header>
              <mat-panel-title class="phase-panel-title">
                {{ getPhaseLabel(phaseModel.phase) }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <!-- Campo filtro -->
            <div class="filter-container">
              <mat-form-field appearance="outline" class="filter-field">
                <mat-label>{{ "MANPOWERHOURS.filter_label" | translate }}</mat-label>
                <input
                  matInput
                  [value]="phaseModel.filterValue"
                  (input)="applyFilter(phaseModel, $event)"
                  [placeholder]="'MANPOWERHOURS.search_placeholder' | translate">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

            <!-- Tabella risorse (OPFPHBRel) -->
            <div class="phase-table-container">
              <table mat-table [dataSource]="phaseModel.dataSource" matSort class="phase-table mat-elevation-z2">

                <!-- Risorsa -->
                <ng-container matColumnDef="userName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "MANPOWERHOURS.col_resource" | translate }}</th>
                  <td mat-cell *matCellDef="let r">{{ r.userName }}</td>
                </ng-container>

                <!-- Livello -->
                <ng-container matColumnDef="level">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "MANPOWERHOURS.col_level" | translate }}</th>
                  <td mat-cell *matCellDef="let r">{{ r.level }}</td>
                </ng-container>

                <!-- Ore -->
                <ng-container matColumnDef="hours">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "MANPOWERHOURS.col_hours" | translate }}</th>
                  <td mat-cell *matCellDef="let r">{{ r.hours }}</td>
                </ng-container>

                <!-- Data -->
                <ng-container matColumnDef="ts">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "MANPOWERHOURS.col_date" | translate }}</th>
                  <td mat-cell *matCellDef="let r">{{ tsToDate(r.ts) | date:'dd/MM/yyyy' }}</td>
                </ng-container>

                <!-- Inizio -->
                <ng-container matColumnDef="tsStart">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "MANPOWERHOURS.col_start" | translate }}</th>
                  <td mat-cell *matCellDef="let r">{{ tsToDate(r.tsStart) | date:'HH:mm' }}</td>
                </ng-container>

                <!-- Fine -->
                <ng-container matColumnDef="tsEnd">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "MANPOWERHOURS.col_end" | translate }}</th>
                  <td mat-cell *matCellDef="let r">{{ tsToDate(r.tsEnd) | date:'HH:mm' }}</td>
                </ng-container>

                <!-- Costo -->
                <ng-container matColumnDef="cost">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "MANPOWERHOURS.col_cost" | translate }}</th>
                  <td mat-cell *matCellDef="let r">{{ r.cost | number:'1.2-2' }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsPhase; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsPhase;"></tr>

                <tr class="mat-row no-data-row" *matNoDataRow>
                  <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumnsPhase.length">
                    <ng-container *ngIf="phaseModel.filterValue; else noResourcesTpl">
                      {{ "MANPOWERHOURS.no_filter_result" | translate }} "<em>{{ phaseModel.filterValue }}</em>"
                    </ng-container>
                    <ng-template #noResourcesTpl>
                      {{ "MANPOWERHOURS.no_resources" | translate }} "<em>{{ getPhaseLabel(phaseModel.phase) }}</em>"
                    </ng-template>
                  </td>
                </tr>
              </table>
            </div>

          </mat-expansion-panel>
        </mat-accordion>

      </mat-expansion-panel>
    </mat-accordion>

  </ng-container>

  <ng-template #noData>
    <p class="no-data-msg">{{ "MANPOWERHOURS.no_data" | translate }}</p>
  </ng-template>

</div>

<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="">{{ "LABEL.CANCEL" | translate }}</button>
</div>